import federation from '/Users/xuanthanh/Desktop/2-years/repo-groups/repo-frontends/angular-mono-space/node_modules/.pnpm/@module-federation+webpack-bundler-runtime@0.8.12/node_modules/@module-federation/webpack-bundler-runtime/dist/index.cjs.js';
import plugin_0 from '/Users/xuanthanh/Desktop/2-years/repo-groups/repo-frontends/angular-mono-space/node_modules/.pnpm/@nx+module-federation@20.3.3_@swc-node+register@1.9.2_@swc+core@1.5.29_@swc+helpers@0.5.17_@t_2xwczorzeircky4qwqtq5p22ua/node_modules/@nx/module-federation/src/utils/plugins/runtime-library-control.plugin.js';

if(!__webpack_require__.federation.runtime){
	var prevFederation = __webpack_require__.federation;
	__webpack_require__.federation = {}
	for(var key in federation){
		__webpack_require__.federation[key] = federation[key];
	}
	for(var key in prevFederation){
		__webpack_require__.federation[key] = prevFederation[key];
	}
}
if(!__webpack_require__.federation.instance){
	var pluginsToAdd = [
		plugin_0 ? (plugin_0.default || plugin_0)() : false,
	].filter(Boolean);
	__webpack_require__.federation.initOptions.plugins = __webpack_require__.federation.initOptions.plugins ? 
	__webpack_require__.federation.initOptions.plugins.concat(pluginsToAdd) : pluginsToAdd;
	__webpack_require__.federation.instance = __webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
	if(__webpack_require__.federation.attachShareScopeMap){
		__webpack_require__.federation.attachShareScopeMap(__webpack_require__)
	}
	if(__webpack_require__.federation.installInitialConsumes){
		__webpack_require__.federation.installInitialConsumes()
	}

	if(!__webpack_require__.federation.isMFRemote && __webpack_require__.federation.prefetch){
	__webpack_require__.federation.prefetch()
	}
}